export default __webpack_public_path__ + "static/media/close-arrow.34d079f9.svg";